import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, map, catchError } from 'rxjs';
import { AuthFacade } from '../../features/auth/facade/auth.facade';

export const authGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  if (!authFacade.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }

  return authFacade.checkSessionStatus().pipe(
    map((isActive) => {
      if (!isActive) {
        return false;
      }
      const onboardingCompleted = typeof window !== 'undefined' && localStorage.getItem('onboardingCompleted') === 'true';
      if (!onboardingCompleted) {
        return router.createUrlTree(['/onboarding']);
      }
      return true;
    }),
    catchError(() => of(true))
  );
};
